var React = require('react');

function FlagCa (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"CA"),React.createElement("g",{"id":"flag-ca","key":1},[React.createElement("path",{"d":"M24 0H0V15.9997H24V0Z","fill":"#F0F0F0","key":0}),React.createElement("path",{"d":"M5.99983 0H0V16.0002H5.99983V0Z","fill":"#D80027","key":1}),React.createElement("path",{"d":"M24.0001 0H18.0002V16.0002H24.0001V0Z","fill":"#D80027","key":2}),React.createElement("path",{"d":"M14.5 9.66661L17 8.33329L15.75 7.66671V6.33339L13.25 7.66671L14.5 5.00007H13.25L12 3L10.75 5.00007H9.5L10.75 7.66671L8.25 6.33339V7.66671L7 8.33329L9.5 9.66661L8.87508 10.9999H11.3751V13H12.6251V10.9999H15.1251L14.5 9.66661Z","fill":"#D80027","key":3})])]);
}

FlagCa.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none"};

module.exports = FlagCa;

FlagCa.default = FlagCa;
